import React from 'react';
import { useTheme } from './hooks/useTheme';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
// import { AppPromo } from './components/AppPromo'; // DISABLED - Will be re-enabled later
import { QuotationCalculator } from './components/QuotationCalculator';
import { Tools } from './components/Tools';
import { Team } from './components/Team';
import { Clients } from './components/Clients';
import { ComingSoon } from './components/ComingSoon';
import { Footer } from './components/Footer';
export function App() {
  const {
    isDark,
    toggleTheme
  } = useTheme();
  return <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300" data-id="element-0">
      <Navigation isDark={isDark} toggleTheme={toggleTheme} data-id="element-1" />
      <Hero data-id="element-2" />
      <Services data-id="element-3" />
      {/* <AppPromo /> */}{' '}
      {/* DISABLED - AppPromo section temporarily disabled */}
      <QuotationCalculator data-id="element-4" />
      <Tools data-id="element-5" />
      <Team data-id="element-6" />
      <Clients data-id="element-7" />
      <ComingSoon data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}